import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { SupportStatus, supportDate } from "@/components/SupportStatus";

export const SupportTicketList = ({ tickets, basePath, admin }) => (
  <div className="divide-y divide-[#E4E3DE] border-y border-[#E4E3DE]" data-testid="support-ticket-list">
    {tickets.length === 0 && (
      <p className="py-14 text-[#707070] text-sm" data-testid="support-tickets-empty">
        Nessun ticket in questa vista.
      </p>
    )}
    {tickets.map(ticket => (
      <Link key={ticket.id} to={`${basePath}/${ticket.id}`}
            className={`group py-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 transition-colors px-3 -mx-2 min-w-0 border-l-[5px] ${ticket.unread_count ? "support-ux-unread-row" : "border-transparent hover:bg-[#F5F5F1]"}`}
            data-testid={`support-ticket-${ticket.id}`}>
        <span className="min-w-0 flex-1">
          {admin && <span className="block text-xs font-semibold text-[#385C44] mb-1 break-words"
                          data-testid={`support-ticket-client-${ticket.id}`}>
            {ticket.author_name || ticket.author_email} · {ticket.tenant_name || "Azienda non indicata"}
          </span>}
          <span className={`block font-serif text-lg text-[#1A1A1A] break-words ${ticket.unread_count ? "font-semibold" : ""}`}
                data-testid={`support-ticket-subject-${ticket.id}`}>
            {ticket.subject}
          </span>
          <span className="text-xs text-[#707070] mt-1 block" data-testid={`support-ticket-meta-${ticket.id}`}>
            {supportDate(ticket.updated_at)} · <MessageCircle className="w-3 h-3 inline" /> {ticket.messages.length}
          </span>
        </span>
        <span className="flex flex-wrap items-center justify-start gap-2 sm:justify-end min-w-0">
          {ticket.unread_count > 0 && <span className="support-ux-unread-count inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold px-3 py-1.5 whitespace-nowrap"
                data-testid={`support-ticket-unread-${ticket.id}`}>
            ● {ticket.unread_count} {ticket.unread_count === 1 ? "aggiornamento" : "aggiornamenti"}
          </span>}
          <SupportStatus status={ticket.status} testId={`support-ticket-status-${ticket.id}`} />
          <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </span>
      </Link>
    ))}
  </div>
);